import { render } from "./DuckMount.vue?vue&type=template&id=b0232704&ts=true"
import script from "./DuckMount.vue?vue&type=script&lang=ts"
export * from "./DuckMount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../home/dory/Software/OrbiLog/docroot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__